import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../config/bdk";

// Per-route head tags. index.html carries static defaults for the "/" route
// (and as a pre-hydration fallback for crawlers that don't run JS), but every
// routed page must override title/description/canonical/og:url here —
// otherwise all routes report the home URL as canonical and Google treats
// them as duplicates of "/".
const Seo = ({ title, description, path, image, jsonLd }) => {
  const url = `${SITE_URL}${path}`;
  const ogImage = image || `${SITE_URL}/creativosbdk.jpg`;
  const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
